import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/tmp/build-69d35d3ff9407e00083c507e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/app/article-detail/components/ArticleDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/components/ExchangeRateBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/components/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/components/ui/AppLogo.tsx");
